import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Some browser extensions (MetaMask) can throw uncaught errors when a page
// attempts to connect to a wallet that isn't available. We guard to prevent
// runtime overlays from breaking the rest of the app.
const shouldSuppressMetaMaskError = (value) => {
  try {
    return String(value || '').toLowerCase().includes('metamask')
      && String(value || '').toLowerCase().includes('connect');
  } catch {
    return false;
  }
};

if (typeof window !== 'undefined' && !window.__metamaskErrorGuardInstalled) {
  window.__metamaskErrorGuardInstalled = true;

  window.addEventListener('unhandledrejection', (event) => {
    if (shouldSuppressMetaMaskError(event?.reason)) {
      event.preventDefault();
    }
  });

  window.addEventListener('error', (event) => {
    if (shouldSuppressMetaMaskError(event?.message)) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
